/** סוגי פנייה — משותף ל-launcher ולעמוד המלא */
export const QUICK_REQUEST_TYPE_BLOCKS = [
  { value: "name_change", label: "שינוי שם נוסע" },
  { value: "date_change", label: "שינוי תאריך" },
  { value: "add_baggage", label: "הוספת מזוודה" },
  { value: "room_change_or_upgrade", label: "שינוי חדר / שדרוג" },
  { value: "general_inquiry", label: "בירור כללי" },
  { value: "other", label: "אחר" },
  { value: "cancellation", label: "ביטול הזמנה" },
];

export const REQUEST_TYPE_OPTIONS = QUICK_REQUEST_TYPE_BLOCKS.map(({ value, label }) => ({
  value,
  label,
}));

/** סוגי פנייה שניתן לפתוח בלי הזמנה / דוקט מקושר — כל הנושאים בגרסה */
export const ORDER_OPTIONAL_REQUEST_TYPES = new Set(
  QUICK_REQUEST_TYPE_BLOCKS.map((b) => b.value)
);

/** תצוגת מספר הזמנה בפנייה כללית (ללא הזמנה) */
export const GENERAL_ORDER_DISPLAY_LABEL = "כללי";

export function isOrderOptionalRequestType(requestType) {
  return ORDER_OPTIONAL_REQUEST_TYPES.has(String(requestType || "").trim());
}

/** סוג ברירת מחדל ל־CTA «פתח פנייה כללית» כשלא נבחר נושא */
export const DEFAULT_GENERAL_REQUEST_TYPE = "general_inquiry";

/**
 * סוג פנייה לזרימת ללא-הזמנה: הנבחר אם מותר, אחרת בירור כללי.
 */
export function resolveGeneralRequestType(requestType) {
  const t = String(requestType || "").trim();
  if (t && isOrderOptionalRequestType(t)) return t;
  return DEFAULT_GENERAL_REQUEST_TYPE;
}

export const PAYMENT_CURRENCY_OPTIONS = [
  { value: "ILS", label: "₪ ILS" },
  { value: "USD", label: "$ USD" },
  { value: "EUR", label: "€ EUR" },
];

export const NEW_OPERATION_REQUEST_PATH = "/p/dashboard/operation-requests/new";

export const OPERATION_REQUEST_MODES = {
  operation_request: "operation_request",
  payment_link: "payment_link",
};

/** סטטוסים לעדכון אדמין — תואם ל-backend ALLOWED_STATUSES */
export const ADMIN_OPERATION_STATUS_OPTIONS = [
  { value: "open", label: "פתוח" },
  { value: "in_progress", label: "בטיפול" },
  { value: "waiting_for_payment", label: "ממתין לתשלום" },
  { value: "paid", label: "שולם" },
  { value: "completed", label: "הושלם" },
  { value: "rejected", label: "נדחה" },
  { value: "cancelled", label: "בוטל" },
];

export function initialPaymentDraft() {
  return {
    amount: null,
    currency: "ILS",
    description: "",
    passengerCount: null,
  };
}

export function isValidNewOperationRequestState(state) {
  if (!state || typeof state !== "object") return false;
  const mode = state.mode;
  if (mode !== OPERATION_REQUEST_MODES.operation_request && mode !== OPERATION_REQUEST_MODES.payment_link) {
    return false;
  }
  const order = state.selectedOrder;
  if (order && typeof order === "object") {
    const id = String(order.id || order.orderId || "").trim();
    return Boolean(id);
  }
  // ללא הזמנה — פנייה לאופרציה מכל סוג מותר ללא הזמנה
  return (
    mode === OPERATION_REQUEST_MODES.operation_request &&
    isOrderOptionalRequestType(state.requestType)
  );
}
